import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Thumbnail from '../Thumbnail/Thumbnail';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { connect } from 'store/modules/base/redux';
import {
  FILMSTRIP_TYPE,
  getActiveParticipantsIds
} from 'store/modules/filmstrip';
import { LAYOUTS } from 'store/modules/video-layout';

const StageFilmstrip = (props) => {
  const { _stageParticipants, _isAudioActive, _isPortrait, isVisible } = props;
  const renderStageParticipants = () => {
    if (_stageParticipants.length == 1) {
      return (
        <Thumbnail
          _currentLayout={LAYOUTS.STAGE_FILMSTRIP_VIEW}
          filmstripType={FILMSTRIP_TYPE.STAGE}
          horizontalOffset={0}
          key={`remote_${_stageParticipants[0]}`}
          participantID={_stageParticipants[0]}
          fullView={true}
          showPopup={false}
        />
      );
    } else if (_stageParticipants.length == 2) {
      return (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: _isPortrait ? 'column' : 'row'
          }}>
          <div
            style={{
              display: 'flex',
              flex: 1,
              position: 'relative'
            }}>
            <Thumbnail
              _currentLayout={LAYOUTS.STAGE_FILMSTRIP_VIEW}
              filmstripType={FILMSTRIP_TYPE.STAGE}
              horizontalOffset={0}
              key={`remote_${_stageParticipants[0]}`}
              participantID={_stageParticipants[0]}
              fullView={true}
              showPopup={false}
            />
          </div>
          <div
            style={{
              display: 'flex',
              flex: 1,
              position: 'relative'
            }}>
            <Thumbnail
              _currentLayout={LAYOUTS.STAGE_FILMSTRIP_VIEW}
              filmstripType={FILMSTRIP_TYPE.STAGE}
              horizontalOffset={0}
              key={`remote_${_stageParticipants[1]}`}
              participantID={_stageParticipants[1]}
              fullView={true}
              showPopup={false}
            />
          </div>
        </div>
      );
    } else
      return (
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="filmstrip__videos remote-videos"
          spacing={1}>
          {_stageParticipants.map((item, index) => (
            <Grid item xs key={index}>
              <Thumbnail
                _currentLayout={LAYOUTS.STAGE_FILMSTRIP_VIEW}
                filmstripType={FILMSTRIP_TYPE.STAGE}
                key={`remote_${item}`}
                participantID={item}
              />
            </Grid>
          ))}
        </Grid>
      );
  };
  if (isVisible && _isAudioActive && _stageParticipants.length > 1) {
    return (
      <div className="stagefilmstrip">
        <div className="stagefilmstrip__videos" id="remoteVideos">
          {renderStageParticipants()}
        </div>
      </div>
    );
  }
};
/**
 * Maps (parts of) the Redux state to the associated {@code DeviceFilmstrip}'s props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state) {
  const activeParticipants = getActiveParticipantsIds(state);
  const { clientWidth, clientHeight } = state['features/base/responsive-ui'];

  return {
    _isAudioActive: state['features/filmstrip'].isAudioActive,
    _stageParticipants: activeParticipants,
    _isPortrait: clientHeight > clientWidth
  };
}
export default React.memo(
  connect(_mapStateToProps)(withBoundary(StageFilmstrip))
);
StageFilmstrip.propTypes = {
  _stageParticipants: PropTypes.array,
  _isAudioActive: PropTypes.bool,
  _isPortrait: PropTypes.bool,
  isVisible: PropTypes.bool
};
